/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Shard(props) {
	const group = useRef();
	const { nodes, materials } = useGLTF("models/Logos/Shard.glb");
	return (
		<group ref={group} {...props} dispose={null}>
			<mesh
				geometry={nodes.Logo_Shards.geometry}
				material={materials["Material.001"]}
				position={[0.05, 2.34, 0]}
				rotation={[1.52, 0, 0]}
				scale={54.32}
			/>
		</group>
	);
}

useGLTF.preload("models/Logos/Butterfly.glb");
